import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEmpty';
import { Grid, Typography } from '@mui/material';
import CentralPageModuleBox from './centralPageModuleBox';
import CircularProgress from '@mui/material/CircularProgress';
import { useCentralPageStyles } from '../centralPageStyles';
import clsx from 'clsx';

const ActiveModules = ({ activeModules, isCentralPage, modulesLoading, tileSize, paperBackground, groups, groupItems }) => {
    const { t } = useTranslation();
    const classes = useCentralPageStyles();
    const [groupedModules, setGroupedModules] = useState({});
    useEffect(() => {
        const grouped = {};
        activeModules.forEach((module) => {
            if (module.groupName) {
                if (!grouped[module.groupName]) {
                    grouped[module.groupName] = [];
                }
                grouped[module.groupName].push(module);
            } else {
                grouped[''] = [module];
            }
        });
        setGroupedModules(grouped);
    }, [activeModules]);

    return modulesLoading ? (
        <CircularProgress className={classes.loadingIcon} />
    ) : _isEmpty(activeModules) ? (
        <Typography>{t('No active modules. Please upgrade to continue.')}</Typography>
    ) : groupItems ? (
        Object.values(groupedModules).map((moduleGroup, _index) => (
            <Grid container item xs={12} gap={2}>
                {moduleGroup.map((module) => (
                    <CentralPageModuleBox
                        key={module.id}
                        module={module}
                        tileSize={tileSize}
                        isCentralPage={isCentralPage}
                        paperBackground={paperBackground}
                    />
                ))}
            </Grid>
        ))
    ) : (
        activeModules.map((module) => (
            <CentralPageModuleBox
                key={module.id}
                module={module}
                tileSize={tileSize}
                isCentralPage={isCentralPage}
                paperBackground={paperBackground}
            />
        ))
    );
};

ActiveModules.propTypes = {
    activeModules: PropTypes.array.isRequired,
    isCentralPage: PropTypes.bool,
    paperBackground: PropTypes.bool,
    tileSize: PropTypes.oneOf(['small', 'medium', 'large']),
};

ActiveModules.defaultProps = {
    tileSize: 'large',
    isCentralPage: false,
    paperBackground: false,
};

export default memo(ActiveModules, _isEqual);
